export const BRAND_NAME = "rynekpierwotny.pl";
export const YEARS_OF_EXPERIENCE = 15;
export const WORKERS_COUNT = 130;
export const BRAND_NAME = "rynekpierwotny.pl";
export const YEARS_OF_EXPERIENCE = 15;
export const WORKERS_COUNT = 130;
